import React from "react";
import {FacebookPost, InstagramPost, PinterestPost, VKPost, FacebookStory, InstagramStory, VKStory, TikTokPost, SnapchatPost, TwitterPost, DouyinPost} from "@lumen-developer/lumen-socials/dist/Previews";

class contentPreview extends React.Component {
    render() {
        return (
            <>
                {(this.props.type === "content" || this.props.type === "stim" || this.props.type.includes("watch")) && (
                    <div
                        className={
                            this.props.lookalike.value === "pn"
                                ? this.props.content.promoDesc === "m"
                                    ? "cont-post-edit-pnmax"
                                    : "cont-post-edit-pnstd"
                                : "cont-post-edit"
                        }
                    >
                        {this.props.lookalike.value === "fb" ? (
                            <FacebookPost
                                post={this.props.content}
                                langCode={"EN"}
                                countryCode={"GB"}
                            ></FacebookPost>
                        ) : this.props.lookalike.value === "ig" ? (
                            <InstagramPost
                                post={this.props.content}
                                langCode={"EN"}
                                countryCode={"GB"}
                            ></InstagramPost>
                        ) : this.props.lookalike.value === "pn" ? (
                            <>
                                <PinterestPost
                                    isStim={this.props.content.promoted}
                                    post={this.props.content}
                                ></PinterestPost>
                                <div
                                    style={
                                        this.props.content.promoDesc === "m"
                                            ? {}
                                            : {
                                                position: "absolute",
                                                backgroundColor: "gainsboro",
                                                width: "calc(50% - 16px)",
                                                margin: "0px 8px",
                                                borderRadius: "8px",
                                                right: "0px",
                                                top: "8px",
                                                height: "calc(100% - 16px)",
                                            }
                                    }
                                ></div>
                            </>
                        ) : this.props.lookalike.value === "vk" ? (
                            <VKPost
                                post={this.props.content}
                                langCode={"EN"}
                            ></VKPost>
                        ) : (
                            <TwitterPost
                                post={this.props.content}
                                langCode={"EN"}
                                countryCode={"GB"}
                            />
                            )}
                    </div>
                )}
                {(this.props.type.includes("reel") || this.props.type.includes("story")) && (
                    <div className="phone">
                        <div className="box">
                            <div className="tok-frame" style={{ width: "375px", height: "667px" }}>
                                {this.props.type.includes("reel") && (
                                    <TikTokPost
                                        isStim={this.props.content.promoted}
                                        post={this.props.content}
                                        langCode={"EN"}
                                        countryCode={"GB"}
                                    ></TikTokPost>
                                )}
                                    {this.props.lookalike.value === "douyin" && (
                                     <DouyinPost
                                     stim_url={this.props.content.src}
                                      tt_profile_src={this.props.content.pic}
                                     tt_profile_name={this.props.content.name}
                                      tt_desc={this.props.content.desc}
                                      tt_songName={this.props.content.song}
                                   tt_promoText={this.props.content.promoA}
                                    isStim={this.props.content.promoted}
                                     tt_likes={this.props.content.likes}
                                     tt_comments={this.props.content.comments}
                                     tt_shares={this.props.content.shares}
                                   langCode={"EN"}
                                    countryCode={"GB"}
                                  ></DouyinPost>
                                   )}


                                {this.props.type.includes("story") && (
                                    <>
                                        {this.props.lookalike.value === "fb" ? (
                                            <FacebookStory
                                                post={this.props.content}
                                            ></FacebookStory>
                                        ) : this.props.lookalike.value === "ig" ? (
                                            <InstagramStory
                                                post={this.props.content}
                                            ></InstagramStory>
                                        ) : (
                                            <VKStory
                                                stim_url={this.props.content.src}
                                                vk_profile_src={this.props.content.pic}
                                                vk_channelName={this.props.content.name}
                                            ></VKStory>
                                        )}
                                    </>
                                )}
                                {this.props.type.includes("snapchat") && (
                                    <SnapchatPost
                                        post={this.props.content.promoted}
                                        isStim={true}                                        langCode={"EN"}
                                        countryCode={"GB"}
                                    ></SnapchatPost>
                                )}
                            </div>
                            <div className="earSpeaker"></div>
                            <div className="toggleSwitch"></div>
                            <div className="volumeRocker"></div>
                            <div className="powerBtn"></div>
                            <div className="homeBtn"></div>
                        </div>
                    </div>
                )}
                {(this.props.type.includes("video")) && (
                    <div className="phone">
                        Preview coming soon
                    </div>
                )}
            </>
        );
    }
}

export default contentPreview;
